"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupsAndClassesSelection = void 0;
var _react = require("react");
var _GroupsAndClassesSelection = require("./GroupsAndClassesSelection.styles");
var _hooks = require("../../../../../hooks");
var _AudiencePicker = require("../../../AudiencePicker.labels");
var _Tabs = require("../../../../../UI/Tabs");
var _Button = require("../../../../../UI/Button");
var _AudienceSelectList = require("../AudienceSelectList");
var _SelectedAudience = require("../SelectedAudience");
var _jsxRuntime = require("react/jsx-runtime");
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var GroupsAndClassesSelection = function GroupsAndClassesSelection(props) {
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var isReadOnly = props.isReadOnly,
    setGroupType = props.setGroupType,
    groupType = props.groupType,
    classesIds = props.classesIds,
    groupsIds = props.groupsIds,
    setViewAndIndex = props.setViewAndIndex,
    setCreateGroupTempData = props.setCreateGroupTempData,
    setStudentsSelectorTempData = props.setStudentsSelectorTempData,
    environmentID = props.environmentID,
    selectedStudentsIds = props.selectedStudentsIds,
    groupsSelectorTempData = props.groupsSelectorTempData;
  var styles = (0, _GroupsAndClassesSelection.useStyles)(props);
  var getLabel = (0, _hooks.useLabels)({
    labels: _AudiencePicker.labels
  });
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    tabs = _useState2[0],
    setTabs = _useState2[1];
  (0, _react.useEffect)(function () {
    setGroupType('classes');
  }, [setGroupType]);
  (0, _react.useEffect)(function () {
    var _tabs = [];
    if (classesIds && classesIds.length > 0) {
      _tabs.push({
        id: 'classes',
        label: "".concat(getLabel('groupsSelectListTools_class')).concat(isMobileView && groupsSelectorTempData !== null && groupsSelectorTempData !== void 0 && groupsSelectorTempData.selectedClassesIds.length ? ' (' + (groupsSelectorTempData === null || groupsSelectorTempData === void 0 ? void 0 : groupsSelectorTempData.selectedClassesIds.length) + ')' : '')
      });
    }
    if (groupsIds && groupsIds.length > 0) {
      _tabs.push({
        id: 'groups',
        label: "".concat(getLabel('groupsSelectListTools_groups')).concat(isMobileView && groupsSelectorTempData !== null && groupsSelectorTempData !== void 0 && groupsSelectorTempData.selectedGroupsIds.length ? ' (' + (groupsSelectorTempData === null || groupsSelectorTempData === void 0 ? void 0 : groupsSelectorTempData.selectedGroupsIds.length) + ')' : '')
      });
    }
    setTabs(_tabs);
  }, [classesIds, getLabel, groupsIds, groupsSelectorTempData === null || groupsSelectorTempData === void 0 ? void 0 : groupsSelectorTempData.selectedClassesIds.length, groupsSelectorTempData === null || groupsSelectorTempData === void 0 ? void 0 : groupsSelectorTempData.selectedGroupsIds.length, isMobileView]);
  var handleTabClick = function handleTabClick(tab) {
    setGroupType(tab.id);
  };
  var defaultStudentsSelectorTempData = {
    groupSearchText: '',
    isGroupSearchOpen: false,
    studentsSearchText: '',
    isStudentsSearchOpen: false,
    selectedGroup: environmentID ? 'all' : classesIds && classesIds.length > 0 ? classesIds[0] : groupsIds && groupsIds.length > 0 ? groupsIds[0] : ''
  };
  var handleCreateGroupClick = function handleCreateGroupClick() {
    setStudentsSelectorTempData(_objectSpread({
      selectedStudentsIds: [].concat()
    }, defaultStudentsSelectorTempData));
    setCreateGroupTempData({
      groupName: '',
      groupId: null
    });
    setViewAndIndex('createGroup', 0);
  };
  var handleSingleStudentsClick = function handleSingleStudentsClick() {
    setStudentsSelectorTempData(_objectSpread({
      selectedStudentsIds: _toConsumableArray(selectedStudentsIds || [])
    }, defaultStudentsSelectorTempData));
    setViewAndIndex('studentsSelector', 0);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-AudiencePicker__groups-and-classes-selection'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectedAudience.SelectedAudience, _objectSpread(_objectSpread({}, props), {}, {
      selectedStudentsIds: isMobileView ? [] : selectedStudentsIds,
      audienceType: groupType || 'classes'
    })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-AudiencePicker__groups-and-classes-selection__list'],
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-AudiencePicker__groups-and-classes-selection__list-header'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles['cc-AudiencePicker__groups-and-classes-selection__list-header__tabs'],
          children: tabs.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tabs.Tabs, {
            id: "groupsAndClassesSelection",
            tabs: tabs,
            onTabClick: handleTabClick
          })
        }), !isReadOnly && !isMobileView && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: styles['cc-AudiencePicker__groups-and-classes-selection__list-header__buttons'],
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
            id: "newGroupButton",
            size: "small",
            view: "alternate",
            color: "primary",
            shape: "roundedRectangle",
            category: "assignActivity",
            label: "newGroup",
            onClick: handleCreateGroupClick,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
              children: getLabel('groupsSelectListTools_newGroup')
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
            id: "singleStudentsButton",
            size: "small",
            view: "alternate",
            color: "primary",
            shape: "roundedRectangle",
            category: "assignActivity",
            label: "singletStudents",
            onClick: handleSingleStudentsClick,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
              children: getLabel('groupsSelectListTools_students')
            })
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AudienceSelectList.AudienceSelectList, _objectSpread(_objectSpread({}, props), {}, {
        audienceType: groupType || 'classes'
      }))]
    })]
  });
};
exports.GroupsAndClassesSelection = GroupsAndClassesSelection;